<template>
  <div class="home">
    <h2 class="mt-4">{{ $t("home.title") }}</h2>

    <hr />
    <p>{{ $t("home.p1") }}</p>
    <p>{{ $t("home.p2") }}</p>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {}
};
</script>
